import { defineMessages } from "react-intl";

const messages = defineMessages({
  applyTemplate: {
    id: "email.creationModal.templates.applyTemplate",
    defaultMessage: "Apply Template",
    description: "Manage email templates modal - Apply Template",
  },
  attachmentsAlert: {
    id: "email.creationModal.templates.attachmentsAlert",
    defaultMessage: "<b>Note:</b> Attachments are not saved to templates.",
    description: "Email template attachments alert",
  },
  cancel: {
    id: "email.creationModal.templates.cancel",
    defaultMessage: "Cancel",
    description: "Cancel",
  },
  clear: {
    id: "email.creationModal.templates.clear",
    defaultMessage: "Clear",
    description: "Clear action",
  },
  clearConfirmationCancel: {
    id: "email.creationModal.templates.clearConfirmation.cancel",
    defaultMessage: "Cancel",
    description: "Clear confirmation cancel",
  },
  clearConfirmationOk: {
    id: "email.creationModal.templates.clearConfirmation.ok",
    defaultMessage: "Clear",
    description: "Clear confirmation ok",
  },
  clearConfirmationText: {
    id: "email.creationModal.templates.clearConfirmation.text",
    defaultMessage: "All changes to template will be lost. Continue?",
    description: "Clear confirmation text",
  },
  delete: {
    id: "email.creationModal.templates.delete",
    defaultMessage: "Delete",
    description: "Manage email templates modal - Delete",
  },
  deleteConfirmationCancel: {
    id: "email.creationModal.templates.deleteConfirmation.cancel",
    defaultMessage: "Cancel",
    description: "Manage email templates modal - Cancel",
  },
  deleteConfirmationOk: {
    id: "email.creationModal.templates.deleteConfirmation.ok",
    defaultMessage: "Delete",
    description: "Manage email templates modal - Delete",
  },
  deleteConfirmationText: {
    id: "email.creationModal.templates.deleteConfirmation.text",
    defaultMessage: "Are you sure? Deleting templates cannot be undone.",
    description: "Manage email templates modal - Are you sure you want to delete this template?",
  },
  emailTemplates: {
    id: "email.creationModal.templates.emailTemplates",
    defaultMessage: "Email Templates",
    description: "Manage email templates modal - Email Templates",
  },
  lessTemplateUsersButtonLabel: {
    id: "email.creationModal.templates.lessTemplateUsersButtonLabel",
    defaultMessage: "Show Less",
    description: "Manage email templates modal - less template users button label",
  },
  moreTemplateUsersButtonLabel: {
    id: "email.creationModal.templates.moreTemplateUsersButtonLabel",
    defaultMessage: "+ {count} more",
    description: "Manage email templates modal - more template users button label",
  },
  mostRecent: {
    id: "email.creationModal.templates.mostRecent",
    defaultMessage: "Most Recent",
    description: "Manage email templates modal - Most Recent",
  },
  okay: {
    id: "email.creationModal.templates.okay",
    defaultMessage: "Okay",
    description: "Okay",
  },
  previewAs: {
    id: "email.creationModal.templates.previewAs",
    defaultMessage: "Preview As",
    description: "Manage email templates modal - Preview As",
  },
  previewTemplateDescription: {
    id: "email.creationModal.templates.previewTemplateDescription",
    defaultMessage:
      'The "Preview As" email feature lets you see how an email would look to a particular recipient, helping you check if personalized details are working correctly.',
    description: "Preview Template Description",
  },
  rename: {
    id: "email.creationModal.templates.rename",
    defaultMessage: "Rename",
    description: "Manage email templates modal - Rename",
  },
  save: {
    id: "email.creationModal.templates.save",
    defaultMessage: "Save",
    description: "Save",
  },
  saveNew: {
    id: "email.creationModal.templates.saveNew",
    defaultMessage: "Save New",
    description: "Manage email templates modal - Save New",
  },
  saveNewDisabled: {
    id: "email.creationModal.templates.saveNewDisabled",
    defaultMessage: "Fill out both subject and body to save new template",
    description: "Manage email templates modal - save new disabled",
  },
  saveNewDisabledReply: {
    id: "email.creationModal.templates.saveNewDisabledReply",
    defaultMessage: "Fill out body to save new template",
    description: "Manage email templates modal - save new disabled for reply",
  },
  saveNewSharedDescription: {
    id: "email.creationModal.templates.saveNewSharedDescription",
    defaultMessage: "This template was shared with you. You can only save a new version.",
    description: "Manage email templates modal - save new shared description",
  },
  saveNewTemplate: {
    id: "email.creationModal.templates.saveNewTemplate",
    defaultMessage: "Save New Template",
    description: "Manage email templates modal - Save New",
  },
  seeMore: {
    id: "email.creationModal.templates.moreTemplates",
    defaultMessage: "More Templates",
    description: "Manage email templates modal - See More",
  },
  selectTemplate: {
    id: "email.creationModal.templates.selectTemplate",
    defaultMessage: "Select Template",
    description: "Manage email templates modal - Select Template",
  },
  share: {
    id: "email.creationModal.templates.share",
    defaultMessage: "Share",
    description: "Manage email templates modal - Share",
  },
  shareDisabledDescription: {
    id: "email.creationModal.templates.shareDisabledDescription",
    defaultMessage: "This template was shared with you. Only the owner can share it.",
    description: "Manage email templates modal - Share disabled description",
  },
  shareTemplateModalSubTitle: {
    id: "email.creationModal.templates.shareModal.subTitle",
    defaultMessage: "Select teams and users below to share this email template.",
    description: "Manage email templates modal - share email template modal sub title",
  },
  shareTemplateModalTitle: {
    id: "email.creationModal.templates.shareModal.title",
    defaultMessage: "Share Email Template",
    description: "Manage email templates modal - share email template modal title",
  },
  templateName: {
    id: "email.creationModal.templates.templateName",
    defaultMessage: "Template Name",
    description: "Template Name",
  },
  templateUsersLabel: {
    id: "email.creationModal.templates.templateUsersLabel",
    defaultMessage: "Shared with {text}",
    description: "Manage email templates modal - Template users label",
  },
  update: {
    id: "email.creationModal.templates.update",
    defaultMessage: "Update",
    description: "Update",
  },
  updateConfirmationCancel: {
    id: "email.creationModal.templates.updateConfirmation.cancel",
    defaultMessage: "No",
    description: "Manage email templates modal - Cancel",
  },
  updateConfirmationOk: {
    id: "email.creationModal.templates.updateConfirmation.ok",
    defaultMessage: "Yes",
    description: "Manage email templates modal - Update",
  },
  updateConfirmationText: {
    id: "email.creationModal.templates.updateConfirmation.text",
    defaultMessage: "This template will be overridden by the current email. Continue?",
    description: "Manage email templates modal - Are you sure you want to update this template?",
  },
  updateDescription: {
    id: "email.creationModal.templates.updateDescription",
    defaultMessage: "Save changes to template",
    description: "Update Description",
  },
  updateSharedConfirmationText: {
    id: "email.creationModal.templates.updateSharedConfirmationText.text",
    defaultMessage:
      "This template will be overridden by the current email. These changes will apply to all users this template is shared with. Continue?",
    description:
      "Manage email templates modal - Are you sure you want to update this shared template?",
  },
});

export default messages;
